(() => {
  // Créer et ajouter le popup au body
  const popup = document.createElement('div');
  popup.className = 'absolute z-50 opacity-0 invisible flex items-center justify-center bg-black/50 transition-all duration-300';
  const t = window.Phill.theme.strings.cart.popup;

  popup.innerHTML = `
    <div class="bg-white w-[330px] h-[230px] p-8 relative flex flex-col items-center justify-center">
      <button 
        data-close-popup
        class="text-[#0B1115] absolute top-0 right-0 p-0 h-14 w-10 flex items-center justify-center"
      >
        <svg class="w-3 h-3 rotate-45 text-[#0B1115]" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" width="2" height="12" class="fill-current"></rect>
          <rect x="12" y="5" width="2" height="12" transform="rotate(90 12 5)" class="fill-current"></rect>
        </svg>
      </button>
      <div class="text-center">
        <p class="font-neueRegular text-[24px] mb-6">${t.title}</p>
        <div class="product-info mb-8">
          <img data-popup-image class="w-[200px] h-[200px] object-cover mx-auto mb-4" src="" alt="">
          <p data-popup-title class="font-neueMedium text-[16px] mb-2"></p>
          <p data-popup-price class="font-neueRegular text-[14px]"></p>
        </div>
        <button 
          class="group relative overflow-hidden uppercase text-[11px] tracking-none leading-[14px] py-[14px] px-[10px] rounded-[20px] w-full h-8 mb-[10px] border border-black bg-black text-white disabled:opacity-50 lg:px-0 flex items-center justify-center"
          data-view-cart-popup
        >
          ${t.view_cart}
        </button>
        <button 
          class="text-[12px] underline font-neueRegular"
          data-close-popup
        >
          ${t.continue_shopping}
        </button>
      </div>
    </div>
  `;
  document.body.appendChild(popup);

  function initQuickAdd() {
    const buttons = document.querySelectorAll('[data-variant-add]');
    
    buttons.forEach(button => {
      // Supprimer les anciens event listeners si présents
      button.removeEventListener('click', handleQuickAdd);
      // Ajouter le nouvel event listener
      button.addEventListener('click', handleQuickAdd);
    });
  }

  function handleQuickAdd(e) {
    const addButton = e.currentTarget;
    
    e.preventDefault();
    e.stopPropagation();
    
    // Vérifier si le variant est disponible en regardant la classe du parent
    const variantContainer = addButton.closest('.w-full');

    if (variantContainer && variantContainer.getAttribute('data-variant-available') === 'false') {
      // Créer un nouveau popup pour produit indisponible
      const unavailablePopup = popup.cloneNode(true);
      unavailablePopup.querySelector('p[class*="text-[24px]"]').textContent = 'Produit indisponible';
      
      // Masquer les éléments inutiles
      unavailablePopup.querySelector('[data-view-cart-popup]').style.display = 'none';
      unavailablePopup.querySelector('[data-popup-price]').style.display = 'none';
      
      // Mettre à jour les informations du produit
      const productImage = addButton.closest('[data-product-item]')?.querySelector('img');
      const productTitle = addButton.closest('[data-product-item]')?.querySelector('[data-product-title]');
      
      if (productImage) unavailablePopup.querySelector('[data-popup-image]').src = productImage.src;
      if (productTitle) unavailablePopup.querySelector('[data-popup-title]').textContent = productTitle.textContent;
      
      // Ajouter le popup au produit
      const productItem = addButton.closest('[data-display-add]');
      if (productItem) {
        unavailablePopup.style.top = '0';
        unavailablePopup.style.left = '0';
        unavailablePopup.style.width = '100%';
        unavailablePopup.style.height = '100%';
        productItem.style.position = 'relative';
        productItem.appendChild(unavailablePopup);
      }
      
      // Afficher le popup
      unavailablePopup.classList.remove('invisible');
      unavailablePopup.classList.add('opacity-100');
      
      // Gérer la fermeture pour tous les éléments avec data-close-popup
      const closeButtons = unavailablePopup.querySelectorAll('[data-close-popup]');
      closeButtons.forEach(btn => {
        btn.onclick = () => {
          unavailablePopup.classList.remove('opacity-100');
          unavailablePopup.classList.add('invisible');
          unavailablePopup.remove();
        };
      });

      // Gérer le clic sur le fond du popup
      unavailablePopup.addEventListener('click', (e) => {
        if (e.target === unavailablePopup) {
          unavailablePopup.classList.remove('opacity-100');
          unavailablePopup.classList.add('invisible');
          unavailablePopup.remove();
        }
      });
      
      return;
    }

    const variantId = addButton.dataset.variantAdd;
    addButton.disabled = true;
    
    fetch(`${window.Phill.routes.cartAdd}.js`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      }),
    })
    .then(r => r.json())
    .then(async response => {
      if (response.status) {
        window.app.emit(['cart:updated', 'cart:error'], null, response);
        return;
      }

      const [cart, cartMarkup] = await Promise.all([
        fetch(`${window.Phill.routes.cart}.js`).then(r => r.json()),
        fetch(`${window.Phill.routes.cart}?sections=global-cart-drawer`).then(r => r.json())
      ]);

      cart.sections = cartMarkup;
      await window.app.emit(['cart:updated', 'cart:render'], { cart });

      // Mettre à jour et afficher le popup
      const productImage = addButton.closest('[data-product-item]')?.querySelector('img');
      const productTitle = addButton.closest('[data-product-item]')?.querySelector('[data-product-title]');
      const productPrice = addButton.closest('[data-product-item]')?.querySelector('[data-product-price]');

      if (productImage) popup.querySelector('[data-popup-image]').src = productImage.src;
      if (productTitle) popup.querySelector('[data-popup-title]').textContent = productTitle.textContent;
      if (productPrice) popup.querySelector('[data-popup-price]').textContent = productPrice.textContent;

      popup.classList.remove('invisible');
      popup.classList.add('opacity-100');

      // Fermer automatiquement après 2 secondes
      setTimeout(() => {
        cleanupPopup(popup);
      }, 2000);

      // Gérer le clic sur le fond du popup
      popup.addEventListener('click', (e) => {
        if (e.target === popup) {
          cleanupPopup(popup);
        }
      });

      // Gérer les clics sur les boutons
      const viewCartBtn = popup.querySelector('[data-view-cart-popup]');
      const closeBtn = popup.querySelector('[data-close-popup]');

      viewCartBtn.onclick = () => {
        cleanupPopup(popup);
        window.app.emit('cart:toggle', { cartOpen: true });
      };

      closeBtn.onclick = () => {
        cleanupPopup(popup);
      };

      // Ajouter le positionnement du popup
      const productItem = addButton.closest('[data-display-add]');
      if (productItem) {
        const rect = productItem.getBoundingClientRect();
        popup.style.top = '0';
        popup.style.left = '0';
        popup.style.width = '100%';
        popup.style.height = '100%';
        productItem.style.position = 'relative';
        productItem.appendChild(popup);
      }
    })
    .finally(() => {
      addButton.disabled = false;
    });
  }

  // Exposer la fonction d'initialisation globalement
  window.initQuickAdd = initQuickAdd;
  window.handleQuickAdd = handleQuickAdd;  // Exposer aussi le handler

  // Initialiser au chargement initial
  document.addEventListener('DOMContentLoaded', () => {
    initQuickAdd();
  });

  function cleanupPopup(popup) {
    popup.classList.remove('opacity-100');
    popup.classList.add('invisible');
    // Attendre la fin de l'animation avant de supprimer le popup
    setTimeout(() => {
      popup.remove();
    }, 300);
  }
})();
